import { render, staticRenderFns } from "./projectStatus.vue?vue&type=template&id=0daae580&scoped=true&"
import script from "./projectStatus.vue?vue&type=script&lang=js&"
export * from "./projectStatus.vue?vue&type=script&lang=js&"
import style0 from "./projectStatus.vue?vue&type=style&index=0&id=0daae580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daae580",
  null
  
)

export default component.exports